export const LINK_WHITELIST = [
  '$%listDashboardUrl%$',
  '$%subscriptionUrl%$',
  '$%pageUrl%$'
];
const MS = 1;
export const SEC = 1000 * MS;
export const MIN = 60 * SEC;
export const HISTORY_SAVE_DURATION = 10 * MIN;
export const CONTENTS_SAVE_DURATION = MIN;
export const COMMON_STYLE_EXCLUDE_COMP = ['footer', 'shop', 'permalink', 'shopA', 'shopB', 'shopC'];
export const LOCAL_STORAGE_SAVE_LIMIT = 5;

const BYTE = 1;
const KB = 1024 * BYTE;
const MB = 1024 * KB;
export const MAX_FILE_SIZE = 5 * MB;
export const SMALL_IMAGE_HEIGHT = 40;
export const DATETIME_FORMAT = 'YYYY. M. D. A h:mm';
export const DATE_FORMAT = 'YYYY. M. D';
export const TIME_FORMAT = 'A h:mm';
export enum SUPPORT_TYPE{
  ALL = "ALL",
  WEB = "WEB",
  EMAIL = "EMAIL"
}
export const TEXT_TEMPLATE = 30;